import React from 'react';
import { fmtDay } from './familyApi';

const STYLES = {
  lifetime: 'bg-emerald-100 text-emerald-800 border-emerald-300',
  active_today: 'bg-green-100 text-green-800 border-green-300',
  scheduled: 'bg-sky-100 text-sky-800 border-sky-300',
  paused: 'bg-amber-100 text-amber-900 border-amber-300',
  expired: 'bg-slate-100 text-slate-600 border-slate-300',
  terminated: 'bg-red-100 text-red-700 border-red-300',
};

export const statusLabel = (access) => {
  switch (access.status) {
    case 'lifetime': return 'Lifetime';
    case 'active_today': return 'Active today';
    case 'scheduled': return `Next: ${fmtDay(access.next_access_date)}`;
    case 'paused': return 'Paused';
    case 'terminated': return 'Terminated';
    default: return 'No upcoming days';
  }
};

export const StatusBadge = ({ access, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${STYLES[access.status] || STYLES.expired}`}
  >
    {statusLabel(access)}
  </span>
);
